import { NewSyncBrief } from "../../../../services/sync-license/types/new-sync-brief";
import { SyncBrief } from "../../../../services/sync-license/types/sync-brief";
import { CallApi, handleJSONResponse } from "./common";

const callAPI = CallApi("sync-license/admin");

export const createSyncBrief = async (
  brief: NewSyncBrief
): Promise<SyncBrief> => {
  const response = await callAPI("", "POST", brief);

  return handleJSONResponse(response);
};

export const getSyncBriefs = async (
  next?: string
): Promise<{ response: SyncBrief[]; nextToken?: string }> => {
  const response = await callAPI(`${next ? `?nextToken=${next}` : ""}`, "GET");

  return handleJSONResponse(response);
};
